import EpisodeResult from './EpisodeResult';

export default EpisodeResult;
